export default {
  ADD_EXHIBITOR: 'Exposant toevoegen',
  NO_EXHIBITOR: 'Je hebt nog geen exposanten toegevoegd!',
  EXHIBITOR_NAME: 'Naam exposant',
  EXHIBITOR_EMAIL: 'E-mail exposant',
  EXHIBITOR_CONTACT: 'Contact met exposanten',
  CITY: 'Stad',
  COUNTRY: 'Country',
  ADDRESS: 'Adres',
  ORGANISATION: 'Organisatie',
  TRANSACTION_ID: 'Transactie-Id',
  DATE_OF_PURCHASE: 'Datum van aankoop',
  DEVICES_COUNT: 'Aantal apparaten',
  ADD_EXHIBITOR_SUCCESS: 'Uw exposantenprofiel is succesvol ingesteld!',
  LICENSE_DETAILS: 'Licentie Details',
  UPDATE_EXHIBITOR_SUCCESS: 'Uw exposantenprofiel is succesvol bijgewerkt!',
  EDIT_EXHIBITOR: 'Exposant bewerken'
}
